import { SortDirection } from "@redotech/redo-views-common/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getActiveMarketingAgentSplits = {
  name: "getActiveMarketingAgentSplits" as const,
  input: z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(20),
    sortKey: z.enum(["startDate", "teamName"]).default("startDate"),
    sortDirection: createEnum(SortDirection).default(SortDirection.DESC),
    searchQuery: z.string().optional(),
  }),
  output: z.object({
    splits: z.array(
      z.object({
        _id: z.string(),
        teamId: z.string(),
        teamName: z.string(),
        startDate: z.date().optional(),
        agentPercentage: z.number(),
      }),
    ),
    totalCount: z.number(),
  }),
};
